// Copyright (c) Zammo Inc.
import React from 'react';
import { Components } from 'botframework-webchat';

import { ReactComponent as DefaultButton } from '../../assets/default-button.svg';
import { ReactComponent as CancelButton } from '../../assets/cancel-button.svg';
import { isIOS } from '../../utils/helpers';

import InteractionLine from './InteractionLine';
import { ButtonWrapper } from './styles';

const { connectMicrophoneButton } = Components;

type Props = {
  className: string;
  click: () => void;
  dictating: boolean;
  disabled: boolean;
  isBotResponding: boolean;
  isChatActive: boolean;
};

export default connectMicrophoneButton()(({ click, dictating }: Props) => (
  <>
    <ButtonWrapper onClick={click}>{!dictating ? <DefaultButton /> : <CancelButton />}</ButtonWrapper>
    {!isIOS() && <InteractionLine dictating={dictating} />}
  </>
));
